export enum TestIds {
  AssetType = 'assetType',
  Assignee = 'assignee',
  AttachFiles = 'attachFiles',
  Contributors = 'contributors',
  Cost = 'cost',
  Departments = 'departments',
  DepreciationMethod = 'depreciationMethod',
  Description = 'description',
  Location = 'location',
  Owners = 'owners',
  PurchaseDate = 'purchaseDate',
  SerialNumber = 'serialNumber',
  Status = 'status',
  Tags = 'tags',
  Title = 'title',
}
